import socket from '@/services/socket.js'

export default {
  /**
   * Get all available categories list.
   *
   * @returns Promise
   */
  getCategories() {
    let action = '/category/get/all'

    return new Promise((resolve, reject) => {
      socket.emit(action, { action }, (error, data) => {
        if (error) {
          reject(new Error(error))
        }

        resolve(data.categories)
      })
    })
  },

  /**
   * Get parent categories settings.
   *
   * @param mode_id
   * @returns Promise
   */
  getByModeId(mode_id) {
    let action = '/category_setting/get_by_mode_id'

    return new Promise((resolve, reject) => {
      socket.emit(action, {
        action,
        mode_id
      }, (error, data) => {
        if (error) {
          reject(new Error(error))
        }

        resolve(data.category_settings)
      })
    })
  },

  /**
   * Set parent categories settings.
   *
   * @param mode_id
   * @param category_id
   * @param mode
   * @returns Promise
   */
  setCategory(mode_id, category_id, action_type) {
    let action = '/category_setting/set'

    let body = {
      mode_id,
      category_id,
      action: action_type,
      log: true
    }

    return new Promise((resolve, reject) => {
      socket.emit(action, {
        body
      }, (error, data) => {
        if (error) {
          reject(new Error(error))
        }

        resolve(data.category_settings)
      })
    })
  },

  /**
   * Remove parent categories settings.
   *
   * @param mode_id
   * @param category_setting_id
   * @returns Promise
   */
  delete(mode_id, category_setting_id) {
    let action = '/category_setting/delete'

    return new Promise((resolve, reject) => {
      socket.emit(action, {
        action,
        category_setting_id,
        mode_id
      }, (error, data) => {
        if (error) {
          reject(new Error(error))
        }

        resolve(data)
      })
    })
  },

  /**
   * Block category.
   *
   * @param mode_id
   * @param category_id
   * @returns Promise
   */
  block(mode_id, category_id) {
    return this.set(mode_id, category_id, 'block')
  },

  /**
   * Show warning on category.
   *
   * @param mode_id
   * @param category_id
   * @returns Promise
   */
  alert(mode_id, category_id) {
    return this.set(mode_id, category_id, 'warn')
  },

  /**
   * Allow category.
   *
   * @param mode_id
   * @param category_id
   * @returns Promise
   */
  allow(mode_id, category_id) {
    return this.set(mode_id, category_id, 'allow')
  },

  /**
   * Add custom content filter instance.
   *
   * @param {string} group_id
   * @param {string} description
   * @param {Array.<string>} keywords
   * @param {Array.<string>} urls
   *
   * @returns Promise
   */
  addCustomFilter(group_id, description, keywords = [], urls = []) {
    const action = '/custom_category/add'

    return new Promise((resolve, reject) => {
      socket.emit(action, {
        action,
        group_id,
        description,
        keywords,
        urls
      }, (error, data) => {
        if (error) {
          reject(new Error(error))
        }

        resolve(data)
      })
    })
  },

  /**
   * Update custom content filter instance.
   *
   * @param {string} category_id
   * @param {string} group_id
   * @param {string} description
   * @param {Array.<string>} keywords
   * @param {Array.<string>} urls
   *
   * @returns Promise
   */
  upadateCustomFilter(category_id, group_id, description, keywords = [], urls = []) {
    const action = '/custom_category/update'

    return new Promise((resolve, reject) => {
      socket.emit(action, {
        action,
        category_id,
        group_id,
        description,
        keywords,
        urls
      }, (error, data) => {
        if (error) {
          reject(new Error(error))
        }

        resolve(data)
      })
    })
  },

  /**
   * Delete custom content filter instance.
   *
   * @param {string} category_id
   * @param {string} group_id
   *
   * @returns Promise
   */
  deleteCustomFilter(category_id, group_id) {
    const action = '/custom_category/delete'

    return new Promise((resolve, reject) => {
      socket.emit(action, {
        action,
        category_id,
        group_id
      }, (error, data) => {
        if (error) {
          reject(new Error(error))
        }

        resolve(data)
      })
    })
  },

  /**
   * Get all custom content filter instances.
   *
   * @param {string} group_idw
   *
   * @returns Promise
   */
  getAllCustomFilters(group_id) {
    const action = '/custom_category/get/all'

    return new Promise((resolve, reject) => {
      socket.emit(action, {
        action,
        group_id
      }, (error, data) => {
        if (error) {
          reject(new Error(error))
        }

        resolve(data.categories)
      })
    })
  }
}